import React, { Component } from 'react';
import PropTypes from 'prop-types';

class QtySelect extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.handleQtyChange = this.handleQtyChange.bind(this);
  }

  handleQtyChange(e) {
    this.props.onChange(e.currentTarget.value);
  }

  render () {
    return(
      this.props.value < 99
          ?
        <select className={`qty-select ${this.props.className}`} value={this.props.value} onChange={this.handleQtyChange}>
          <option key={''} value="">Qty</option>
          {[...Array(Math.min(99, this.props.max + 1) - this.props.min).keys()].map(i =>
            <option key={i + this.props.min} value={i + this.props.min}>{i + this.props.min}</option>
          )}
          {
            this.props.max >= 99 &&
              <option key={99} value="99">99+</option>
          }
        </select>
          :
        <input className={`qty-select ${this.props.className}`} type="number" defaultValue={this.props.value} onBlur={this.handleQtyChange} />

    );
  }
}

QtySelect.defaultProps = {
  min: 0,
  max: 9999,
  className: '',
};

QtySelect.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.string,
};

export default QtySelect;
